export default __webpack_public_path__ + "static/media/rabbit2.46ce266f.png";